// Copyright © 2021 Move Closer

import { AnyObject } from '@movecloser/front-core'

import { AbstractTypeDriver } from './abstract'
import { DescriptionOfContent, DriverConfig, RelatedRecord, RelatedType, ResolvesDriver } from '../contracts'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export class ContentDriver<M extends AnyObject = DescriptionOfContent, D extends AnyObject = M> extends AbstractTypeDriver<M, D> {
  /**
   * Key that stores RelatedType.
   * @protected
   */
  protected typeKey: RelatedType = RelatedType.Content

  /**
   * @inheritDoc
   */
  public resolve (id: string, record: RelatedRecord, config: DriverConfig, driverResolver: ResolvesDriver): M {
    const description = super.resolve(id, record, config, driverResolver) as unknown as DescriptionOfContent

    const authorDriver = driverResolver(RelatedType.Author)
    const fileDriver = driverResolver(RelatedType.File)
    const labelsDriver = driverResolver(RelatedType.Label)

    let author
    let coverProperty
    const labels = []

    try {
      author = authorDriver.resolve(`${description.author.value}`, record, config, driverResolver)
    } catch (e) {
      author = undefined
    }

    if (description.properties && typeof description.properties.cover === 'object' && description.properties.cover !== null) {
      coverProperty = { ...description.properties.cover }

      try {
        coverProperty.image = fileDriver.resolve(`${description.properties.cover.image.value}`, record, config)
      } catch (e) {
        coverProperty.image = undefined
      }
    }

    if (description.properties && Array.isArray(description.properties.labels) && description.properties.labels.length > 0) {
      for (const l of description.properties.labels) {
        try {
          const label = labelsDriver.resolve(l.value, record, config)
          labels.push(label)
        } catch (e) {
          console.warn(e)
        }
      }
    }

    return {
      ...description,
      properties: {
        ...description.properties,
        labels: labels,
        cover: coverProperty
      },
      author: author
    } as unknown as M
  }
}
